export default __webpack_public_path__ + "static/media/istanbul_heart_mobile.4756b74f.png";